export default __webpack_public_path__ + "static/media/domain-card.b2bb224b.png";